import _ from "lodash";
import FormsAI from "@/components/forms/FormsAI";

import ScoredFormParameter from "@/server/com/silkplm/engine/actions/ScoredFormParameter";
import ScoredParameter from "@/server/com/silkplm/engine/actions/ScoredParameter";
import actions from "@/ActionRouter";

/**
 * @param action {ActionCall}
 */
export async function executeAction(action){
    if(actions.hasOwnProperty(action.name)){
        let args = [];
        action.parameters.forEach(param => {
            args.push(param);
        });
        action.formParameters.forEach(param => {
            args.push(param);
        });
        args = _.sortBy(args, "order");

        await actions[action.name](action, args.map(arg => {

            if(arg instanceof ScoredFormParameter || arg.paramType === "ScoredFormParameter") {
                return arg.formConfig;
            }
            if(arg instanceof ScoredParameter || arg.paramType === "ScoredParameter"){
                if(arg.placeholderType === "$$FormEntity"){
                    return arg;
                }
                return arg.parameter;
            }

            if(arg.placeholderType?.startsWith("$$")) {
                return arg;
            }
            return arg.parameter;
        }));
    }
    else{
        Log.warn("Action not found:" + action.name, true);
    }
    return true;
}


export default function fillActionWithData(a) {
    if (a.type === "bot") {
        a.filledLabel = a.botResponse;
        return;
    }
    let label = _.escape(a.filledLabel);
    let implicitFormConfig = null;
    a.parameters.forEach(param => {
        if (param.formConfig) {
            implicitFormConfig = param.formConfig;
            let smartLabel = FormsAI.getEntityLabel(param.formConfig, param.parameter);
            if (smartLabel.length > 60) {
                smartLabel = smartLabel.substr(0, 56) + "...";
            }
            label = label.replace(param.placeholder, "<i>" + _.escape(smartLabel) + "</i>");
        } else {
            label = label.replace(param.placeholder, "<i>" + _.escape(param.label) + "</i>");
        }
        if(label && label.substr(0, 1).toLowerCase() === label.substr(0, 1)){
            label = label.substr(0, 1).toUpperCase() + label.substr(1);
        }
    });

    a.formParameters.forEach(param => {
        label = label.replace(param.placeholder, "" + _.escape(param.formConfig.entityPlural) + "");
    });

    if (!a.formConfig) {
        a.formConfig = implicitFormConfig;
    }
    const parts = a.icon.split(".");
    if (parts.length > 1) {
        if (parts[0] == "$$Form") {
            a.icon = a.formConfig.icon;
            if (parts.length > 2) {
                const modifier = parts[2];
                switch (modifier) {
                    case "remove":
                        a.iconModifier = "trash";
                        break;
                    case "add":
                        a.iconModifier = "plus";
                        break;
                    case "list":
                        a.iconModifier = "";
                        break;
                    case "edit":
                        a.iconModifier = "pen";
                        break;
                    default:
                        a.iconModifier = parts[2];
                }
            }
        }
    }
    a.filledLabel = label; //+ " (" + a.weight + ")";

}
